import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@treasuryspring/spring-ui';
import { useMemo } from 'react';

import { useRatesQuery } from '@/api/query';
import { useAppStore } from '@/stores/useAppStore';

import CurrencyLabel from './currency-label';

function StateSelectors() {
  const {
    selectedCurrency,
    setSelectedCurrency,
    selectedRating,
    setSelectedRating,
    selectedSector,
    setSelectedSector,
  } = useAppStore();
  const { rates } = useRatesQuery().data || {};

  const availableCurrencies = useMemo(
    () => (rates ? Object.keys(rates) : []),
    [rates]
  );

  return (
    <div className="lg:gap-m md:gap-s gap-xs flex flex-col items-start sm:flex-row md:items-center">
      <Select value={selectedCurrency} onValueChange={setSelectedCurrency}>
        <SelectTrigger className="w-full sm:w-fit" size="small">
          <SelectValue placeholder="Currency" />
        </SelectTrigger>
        <SelectContent>
          {availableCurrencies.map((currency) => (
            <SelectItem key={currency} value={currency}>
              <CurrencyLabel currency={currency} />
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Select value={selectedRating} onValueChange={setSelectedRating}>
        <SelectTrigger className="w-full md:w-fit" size="small">
          <SelectValue placeholder="Rating" />
        </SelectTrigger>
        <SelectContent>
          {(rates && rates[selectedCurrency]
            ? Object.keys(rates[selectedCurrency])
            : []
          ).map((rating) => (
            <SelectItem key={rating} value={rating}>
              {rating}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Select value={selectedSector} onValueChange={setSelectedSector}>
        <SelectTrigger className="w-full md:w-fit" size="small">
          <SelectValue placeholder="Sector" />
        </SelectTrigger>
        <SelectContent>
          {(rates &&
          rates[selectedCurrency] &&
          rates[selectedCurrency][selectedRating]
            ? Object.keys(rates[selectedCurrency][selectedRating])
            : []
          ).map((sector) => (
            <SelectItem key={sector} value={sector}>
              {sector}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}

export default StateSelectors;
